import { useState } from "react";
import teamAPI from "../../../services/teamApi";
import s from "../clinic.module.css";
import u from "../../ui/ui.module.css";
import {
  Button,
  Field,
  Input,
  Textarea,
  FormSection,
  FormGrid,
  FormGridSpan,
  useToast,
} from "../../ui";

export default function AdminDoctorDataForm({
  edit,
  setEdit,
  onSubmit,
  newPassword,
  setNewPassword,
  onSetPassword,
  onDeactivate,
  isActive,
  userId = null,
}) {
  const toast = useToast();
  const [inviteBusy, setInviteBusy] = useState(false);
  const [inviteUrl, setInviteUrl] = useState("");

  const sendInvite = async () => {
    if (!userId) {
      toast.error("Сначала сохраните email — аккаунт для входа ещё не создан");
      return;
    }
    if (!String(edit.email || "").trim()) {
      toast.error("Укажите email для приглашения");
      return;
    }
    setInviteBusy(true);
    try {
      const res = await teamAPI.resendInvite(userId);
      if (res?.result !== 0) {
        toast.error(res?.error || "Не удалось отправить приглашение");
        return;
      }
      if (res.invite_url && !res.email_sent) {
        setInviteUrl(res.invite_url);
        try {
          await navigator.clipboard.writeText(res.invite_url);
          toast.success("Ссылка скопирована (письмо не отправлено)", 6000);
        } catch {
          toast.success(res.message || "Ссылка готова", 6000);
        }
      } else {
        setInviteUrl("");
        toast.success(res.message || "Приглашение отправлено");
      }
    } catch (e) {
      toast.error(e.response?.data?.error || "Не удалось отправить приглашение");
    } finally {
      setInviteBusy(false);
    }
  };

  const copyInviteUrl = async () => {
    if (!inviteUrl) return;
    try {
      await navigator.clipboard.writeText(inviteUrl);
      toast.success("Ссылка скопирована");
    } catch {
      toast.error("Не удалось скопировать");
    }
  };

  return (
    <form onSubmit={onSubmit} className={s.patientDataForm}>
      <FormSection
        title="Профиль"
        description="Группы тренера настраиваются на вкладке «Группы»"
      >
        <FormGrid>
          <FormGridSpan>
            <Field label="ФИО">
              <Input
                required
                value={edit.full_name}
                onChange={(e) =>
                  setEdit({ ...edit, full_name: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
          <FormGridSpan>
            <Field label="Описание">
              <Textarea
                className={u.textareaCompact}
                rows={3}
                value={edit.description}
                onChange={(e) =>
                  setEdit({ ...edit, description: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
        </FormGrid>
      </FormSection>

      <FormSection
        title="Вход в портал тренера"
        description="Отправьте приглашение на email — тренер задаст пароль по ссылке"
      >
        <FormGrid>
          <Field label="Email для входа">
            <Input
              type="email"
              value={edit.email}
              onChange={(e) => setEdit({ ...edit, email: e.target.value })}
            />
          </Field>
          <Field label="Новый пароль" hint="Минимум 8 символов">
            <div className={s.inlineFieldRow}>
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <Button type="button" variant="secondary" onClick={onSetPassword}>
                Задать пароль
              </Button>
            </div>
          </Field>
          <FormGridSpan>
            <div className={s.inlineFieldRow}>
              <Button
                type="button"
                variant="secondary"
                onClick={sendInvite}
                disabled={inviteBusy || !userId}
              >
                {inviteBusy ? "Отправка…" : "Отправить приглашение"}
              </Button>
            </div>
            {!userId ? (
              <p className={s.groupsHubScheduleHint}>
                Сохраните email, чтобы создать аккаунт и отправить приглашение.
              </p>
            ) : null}
            {inviteUrl ? (
              <Field label="Ссылка приглашения">
                <div className={s.inlineFieldRow}>
                  <Input value={inviteUrl} readOnly />
                  <Button type="button" variant="secondary" onClick={copyInviteUrl}>
                    Копировать
                  </Button>
                </div>
              </Field>
            ) : null}
          </FormGridSpan>
        </FormGrid>
      </FormSection>

      <div className={u.formActions}>
        <Button type="submit">Сохранить</Button>
        {isActive ? (
          <Button type="button" variant="danger" onClick={onDeactivate}>
            Деактивировать тренера
          </Button>
        ) : null}
      </div>
    </form>
  );
}
